import { IDynamicTabPanel } from '../interfaces/dynamic-tab.interface';
import DashboardReasons from '../components/dashboard/dashboard-reasons';
import DashboardSignatory from '../components/dashboard/dashboard-signatory';

export const DASHBOARD_TABS_CONSTANT: IDynamicTabPanel[] = [
  { label: 'Reasons', element: <DashboardReasons /> },
  { label: 'Signatory', element: <DashboardSignatory /> },
];
